import React, { Component } from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { common } from '@kurtosys/ksys-app-template';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import Wrapper from './styledComponents/Wrapper.js';
import { IDropdownProps, IDropdownState } from './models';

const DropdownComponent = components.base.Dropdown.Dropdown;
const VisuallyHidden = components.base.VisuallyHidden.VisuallyHidden;
const Translate = components.base.Translate.Translate;

class RawDropdown extends Component<IDropdownProps, IDropdownState> {
	static configurationKey = 'dropdown' as const;
	static styleKey = 'dropdown' as const;

	dropdownMessageId = `dropdown_message_${common.commonUtils.generateGuid()}`;

	constructor(props: IDropdownProps) {
		super(props);
	}
	render() {
		const { className, dropdownStore } = this.props;

		if (!dropdownStore) {
			return null;
		}

		const { props } = dropdownStore;

		if (props && props.items) {
			return (
				<Wrapper className={className}>
					<DropdownComponent {...props} ariaDescribedBy={this.dropdownMessageId} />
					<VisuallyHidden>
						<span role="alert" aria-live="polite" id={this.dropdownMessageId}>
							<Translate>{dropdownStore.vHiddenMessage}</Translate>
						</span>
					</VisuallyHidden>
				</Wrapper>
			);
		}

		return null;
	}
}

export const Dropdown = inject('appStore', 'dropdownStore')(observer(RawDropdown));
export default InjectedStyledComponent(Dropdown, 'dropdown');
